module.exports = __webpack_public_path__ + "img/call.cfc63781.jpg";